import React, { useEffect, useState } from "react";
import "./Announcements.css";

const Announcements = () => {
  const [announcements, setAnnouncements] = useState({});
  const [expanded, setExpanded] = useState({
    "Today": true,
    "Last Week": false,
    "This Month": false,
    "Older": false,
  });

  useEffect(() => {
    // Fetch announcements from the backend
    fetch("http://localhost/eac_backend/fetchann.php")
      .then((response) => response.json())
      .then((data) => {
        setAnnouncements(data);
      })
      .catch((error) => {
        console.error("Error fetching announcements:", error);
      });
  }, []);

  const toggleExpand = (category) => {
    setExpanded((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  return (
    <div className="ann-page">
      <header className="contact-header">
        <div className="header-content">
          <h1>Announcements</h1>
          <p>Stay updated with the latest news and events! We're always here to support you—reach out anytime for assistance.</p>

        </div>
      </header>
      <div className="announcements-container">
        {/* <h2>Announcements</h2> */}
        {Object.keys(announcements).map((category) => (
          <div key={category} className="announcement-section">
            <div
              className="announcement-category"
              onClick={() => toggleExpand(category)}
            >
              <h3>{category}</h3>
              <span>{expanded[category] ? "-" : "+"}</span>
            </div>
            {expanded[category] && (
              <div className="announcement-list">
                {announcements[category].map((announcement) => (
                  <div key={announcement.id} className="announcement-item">
                    <h4>{announcement.title}</h4>
                    {/* <p>{announcement.introduction}</p> */}
                    <p>{announcement.details}</p>
                    <small>{new Date(announcement.date).toLocaleDateString()}</small>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Announcements;
